import { apiClient, handleApiError } from '../api-client';

/**
 * Version API functions
 * Handles fetching application version information
 */

/**
 * Version information interface
 */
export interface VersionInfo {
  gitSha: string;
  shortSha: string;
  buildTime: string;
  environment: string;
}

/**
 * Fetches version information from the API
 *
 * @returns Promise that resolves to version info
 */
export const fetchVersionInfo = async (): Promise<VersionInfo> => {
  try {
    return apiClient.get<VersionInfo>('/version');
  } catch (error) {
    return handleApiError(error, 'Failed to fetch version info');
  }
};
